<template>
  <div>
    <div>
      <el-upload
        v-show="copyFileList.length < limit"
        :disabled="disabled"
        :drag="drag && copyFileList.length < limit"
        ref="upload"
        style="display: block;"
        action="https://xx.yy.zz"
        :file-list="fileList"
        :limit="limit"
        :auto-upload="false"
        :on-change="onChange"
        :before-upload="beforeUpload"
        :multiple="multiple"
        :http-request="importListFile"
        :class="{ show_upload_text: !(copyFileList.length < limit) }"
        :show-file-list="false"
        :on-exceed="handleExceed"
      >
        <template v-if="drag && copyFileList.length < limit">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            一次只能上传一个文件，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            {{ tip }}
          </div>
        </template>
        <template v-if="!drag && copyFileList.length < limit">
          <el-button :disabled="disabled" size="small" type="primary">点击上传</el-button>
        </template>
      </el-upload>
      <div v-show="copyFileList.length" class="inline-block">
        <slot name="content">
          <div
            :key="index"
            v-for="(item, index) in copyFileList"
            class="p-0px hover:bg-slate-100 flex items-center"
          >
            <span class="cursor-pointer" @click="onPreview(item)">{{ item.name }}</span>
            <span class="ml-5px cursor-pointer" v-if="!disabled" @click="beforeRemove(item)">
              <i class="icon-bg-delete iconfont hover:text-rose-700 hover:shadow"></i>
            </span>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { FileApi } from '@wiz-api/file-management'
import { filter, map, eq } from 'lodash'

const fileApi = new FileApi()

export default {
  name: 'form-upload',
  model: {
    prop: 'fileIds',
    event: 'change',
  },
  props: {
    // 文件数量
    limit: {
      default: 1,
    },
    // 是否多传
    multiple: {
      default: false,
    },
    // 文件大小不超过，单位m，默认100，
    maxSize: {
      type: Number,
      default: 100,
    },
    // 可上传文件类型
    accept: {
      type: Array,
      default: () => {
        return ['pdf', 'jpg', 'png']
        // 图片格式默认前4个
        // 'jpeg', 'gif', 'psd', 'bmp', 'tiff'
      },
    },
    disabled: {
      disabled: false,
    },
    fileIds: {
      default: '',
    },
    // 是否能拖拽，拖拽比较占位置，不拖拽使用按钮上传
    drag: {
      default: true,
    },
  },
  computed: {
    tip() {
      return `仅支持上传${this.accept.join('/')}格式，每次上传不超过${
        this.maxSize
      }M`
    },
  },
  data() {
    return {
      // fileList上传的时候会改变值，自己写个copyFileList
      fileList: [],
      copyFileList: [],
      // 图片预览信息
      imgContent: null,
    }
  },
  created() {
    if (this.fileIds) {
      this.fnGetFileList(this.fileIds.split(','))
    } else {
      this.copyFileList = []
    }
  },
  watch: {
    fileIds(fileIds) {
      if (fileIds) {
        this.fnGetFileList(fileIds.split(','))
      } else {
        this.fileList = []
        this.copyFileList = []
      }
    },
  },
  methods: {
    // 文件超出限制钩子
    handleExceed() {
      this.$message.warning('文件个数超出限制')
    },
    beforeUpload(file) {
      const maxSize = file.maxSize / 1024 / 1024
      const name = file.name
      if (maxSize > this.maxSize) {
        this.$message.warning(`上传文件大小不能超过${this.maxSize}M`)
        return false
      }
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix)
      ) {
        this.$message.warning(`上传文件只能是${this.accept.join('/')}`)
        return false
      }
      return true
    },
    // 获取附件列表
    async fnGetFileList(fileIds) {
      this.fileList = []
      this.copyFileList = []
      fileIds.forEach(async (id) => {
        const [err, res] = await fileApi.get(id)
        if (!err) {
          this.copyFileList.push(res)
          this.fileList.push(res)
        }
      })
    },
    // 附件，删除
    async fnDeleteFileReg() {
      const [err, res] = await fileApi.callDelete(this.fifileApiuploadleId)
      if (!err) {
        this.$message({
          message: '删除成功',
          type: 'success',
        })
        this.fileList = []
        this.$emit('change', '')
      }
    },
    async importListFile(params) {
      // 上传附件
      const [err, res] = await fileApi.upload({
        files: [params.file],
      })
      if (!err) {
        this.$emit(
          'change',
          [...this.copyFileList, ...res]
            .map((i) => {
              return i.id
            })
            .join(',')
        )
        return
      }
      // 如果上传失败则删除本次文件
      this.fileList = filter(this.fileList, (item) => {
        return !eq(item.uid, params.file.uid)
      })
    },
    onChange(file, fileList) {
      this.fileList = fileList
      this.$refs.upload.submit()
    },
    beforeRemove(file) {
      return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action) => {
          if (action === 'confirm') {
            const [err, res] = await fileApi.callDelete(file.id)
            if (!err) {
              this.copyFileList = filter(this.copyFileList, (i) => {
                return i.id !== file.id
              })
              this.fileList = this.copyFileList
              this.$emit(
                'change',
                map(this.copyFileList, (i) => {
                  return i.id
                }).join(',')
              )
            }
          }
        },
      })
    },
    onPreview(file) {
      this.downLoadFile(file)
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.show_upload_text {
  ::v-deep {
    .el-upload--text {
      display: none;
    }
  }
}
::v-deep .el-dialog__body {
  padding-top: 0px;
  height: calc(100% - 60px);
}
</style>
